export default __webpack_public_path__ + "static/media/dustbin-active.2213f7ed.svg";